import { BasketApiService } from '@api_patient/basket_api.service';
import { DynamicFormAnswer, DynamicFormAnswers, DynamicFormsApiService } from '@api_patient/dynamic_forms_api.service';
import { FormGraphApiModel } from '@visiba/api-vcs-client-v2';
import { FormDataProvider } from './form_data_provider';

export class FormDataProviderBasket implements FormDataProvider {
	private unitId: number;
	private formId: number;
	private basketId: number;
	private basketProductId: number;

	constructor(
		unitId: number,
		formId: number,
		basketId: number,
		basketProductId: number,
		private readonly dynamicFormsApiService: DynamicFormsApiService,
		private readonly basketApiService: BasketApiService,
	) {
		this.unitId = unitId;
		this.formId = formId;
		this.basketId = basketId;
		this.basketProductId = basketProductId;
		// Empty
	}

	public async getForm(): AsyncResult<FormGraphApiModel> {
		const result = await this.dynamicFormsApiService.getById(this.unitId, this.formId);

		if (result.err) {
			return Err(result.err);
		}

		return Ok(result.ok.data);
	}

	public async getAnswers(): AsyncResult<DynamicFormAnswers> {
		const result = await this.basketApiService.getFormAnswers(this.basketId, this.basketProductId, this.formId);

		if (result.err) {
			return Err(result.err);
		}

		return Ok({
			completed: false,
			answers: result.ok.data.map((answer) => ({
				boolValue: answer.BoolAnswer,
				choices: answer.MultiAnswer ?? [],
				intValue: answer.IntValue,
				questionId: answer.QuestionId,
				stringValue: answer.TextAnswer,
			})),
		});
	}

	public async answer(answers: DynamicFormAnswer[]): AsyncResult {
		const result = await this.basketApiService.postFormAnswers(
			this.basketId,
			this.basketProductId,
			this.formId,
			answers.map((answer) => ({
				BoolAnswer: answer.boolValue ?? null,
				IntValue: answer.intValue ?? null,
				MultiAnswer: answer.choices.length ? answer.choices : null,
				QuestionId: answer.questionId,
				TextAnswer: answer.stringValue ?? null,
			})),
		);

		if (result.err) {
			return Err(result.err);
		}

		return Ok();
	}

	public setCompletion(): Result {
		return Ok();
	}
}
